import { render, staticRenderFns } from "./ExportFileDetails.vue?vue&type=template&id=5d2f1bfe"
import script from "./ExportFileDetails.vue?vue&type=script&lang=js"
export * from "./ExportFileDetails.vue?vue&type=script&lang=js"
import style0 from "./ExportFileDetails.vue?vue&type=style&index=0&id=5d2f1bfe&prod&lang=scss&scpoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports